import { render, staticRenderFns } from "./stationeryRecord-list.vue?vue&type=template&id=6b6fa706&scoped=true"
import script from "./stationeryRecord-list.vue?vue&type=script&lang=js"
export * from "./stationeryRecord-list.vue?vue&type=script&lang=js"
import style0 from "./stationeryRecord-list.vue?vue&type=style&index=0&id=6b6fa706&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b6fa706",
  null
  
)

export default component.exports